import type { MESSAGE_SENDER, RESOURCE_TYPES } from './enums';
import type { EntityState } from 'state/modules/entity/types';
import type { AppState } from 'state/modules/app/types';
import type { MessagingState } from 'state/modules/messaging';
import type { TourState } from 'state/modules/tour';
import type { UiState } from 'state/modules/ui';
import type { UserState } from 'state/modules/user';
import type { LessonPlannerState } from 'state/modules/lessonPlanner';

export * from './enums';

export type Resource = any;
export type CharacterType = any;
export type CharacterCase = any;
export type ToggleData = any;
export type ElementPosition = any;
export type ElementJustification = any;
export type BadgeType = any;
export type License = any;
export type Product = any;
export type UserSetting = any;

export type Workbook = {
  coverImageUrl: string;
  edition: string | number;
  gradeLevel: string;
  id: number;
  locale: string;
  orientation: string;
  pageOffset: number;
  primaryColor: string;
  products: Array<{ productId: number; productCurriculumId: number }>;
  secondaryColor: string;
  sortIndex: number;
  teachersGuides: any[];
  textColor: string;
  title: string;
  totalPages: number;
  type: 'workbook' | string;
  bookCode: string;
  bookUrl?: string;
  content?: any;
  pageDetails?: any;
};

export type WorkbookMatch = any;
export type PopOverOrientation = any;

export type CharacterTypeSectionState = any;
export type PageDetail = any;
export type Locale = any;
export type BookCode = any;
export type VideoPlayer = any;
export type AppStoreState = {
  app: AppState;
  entity: EntityState;
  messaging: MessagingState;
  tour: TourState;
  ui: UiState;
  user: UserState;
  lessonPlanner: LessonPlannerState;
  assignmentTracking: any;
};
export type LiteResource = any;
export type WorkbookState = any;
export type UserSettingTypes = any;

export type FilterGroup = any;
export type FilterTag = any;
export type WorkbookToCGrouping = any;

export type ProductCopyrightTerms = {
  productCurriculumId: number;
  accepted?: string;
  viewed?: string;
};
export interface CopyrightTerms {
  [productCode: string]: ProductCopyrightTerms;
}

export type FtueTour = any;
export type UserFavorite = any;

export type TypographyType = any;
export type ResourceState = any;
export type AssessmentState = any;
export type TourStep = any;

export type ViewedTour = any;
export type CharacterListState = any;
export type ResourcesState = any;
export type FeatureToggle = any;

export type GradeLevel = any;
export type BookParams = any;
export type ResourcesVariant =
  | 'woodPieces'
  | 'lnf'
  | 'wdt'
  | 'animation'
  | 'music'
  | 'video'
  | 'ourWorld'
  | 'pdf'
  | 'support'
  | 'karaoke'
  | 'audio';

export type MediaVariant = 'video' | 'audio' | undefined;
export type Frametype = RESOURCE_TYPES.IFRAME_PLAYER | RESOURCE_TYPES.AV_PLAYER;

export type Assignment = {
  id: number;
  title: string;
  dateAssigned: string;
  dateDue: string;
  studentIds?: number[];
  classroomId: number;
  unreadMessageCount: number;
  attempts?: Attempt[];
};

export type Attempt = {
  studentId: number;
  status: any;
  files: any[];
  unreadMessages: any[];
};

export type MessageFile = {
  filepath: string;
  id: number;
  mimeType: string;
  ownerId: number;
  size: number;
  title: string;
  type: string;
};

export type Message = {
  id: number;
  attemptId: number;
  text: string;
  studentId?: number;
  userId: number;
  sender: MESSAGE_SENDER;
  dateSent: string;
  dateOpened?: string | null;
  file?: MessageFile;
};

export const NON_EDIT_ATTEMPT_STATUSES = {
  IN_PROGRESS: 'inProgress',
  COMPLETED: 'completed'
};

export type { UserState };
